import { render, staticRenderFns } from "./HwSdk.vue?vue&type=template&id=2c790d19&scoped=true"
import script from "./HwSdk.vue?vue&type=script&lang=js"
export * from "./HwSdk.vue?vue&type=script&lang=js"
import style0 from "./HwSdk.vue?vue&type=style&index=0&id=2c790d19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c790d19",
  null
  
)

export default component.exports